module.exports = __webpack_public_path__ + "img/storagePriceBackground.0ea1cd8f.png";